/* Proceed-to-checkout CTA for Quick Add Drawer — robust add-to-cart detection */
(() => {
  if (window.__CIB_CTA_INIT) return; // avoid double init
  window.__CIB_CTA_INIT = true;

  // Where to show
  const DRAWERS = 'quick-add-drawer.drawer, .drawer.quick-add-drawer, .quick-add, .quick-add-modal, .drawer[aria-hidden="false"]';

  function getOpenDrawer() {
    // Prefer visible/active
    const sel = [
      'quick-add-drawer.drawer[aria-hidden="false"]',
      '.drawer.quick-add-drawer[aria-hidden="false"]',
      '.quick-add.is-open',
      '.quick-add-modal.is-open',
      '.drawer.is-open',
      '.modal.is-open'
    ].join(', ');
    return document.querySelector(sel) || document.querySelector(DRAWERS);
  }

  function showCTA(root) {
    const container = root || getOpenDrawer();
    if (!container) return;
    const cta = container.querySelector('.cib-quick-checkout-cta');
    if (cta) cta.hidden = false;
  }

  function hideAllCTA() {
    document.querySelectorAll('.cib-quick-checkout-cta').forEach(el => (el.hidden = true));
  }

  // --- Detect ANY add-to-cart (fetch or XHR) ---
  if (!window.__CIB_CTA_FETCH_PATCHED) {
    window.__CIB_CTA_FETCH_PATCHED = true;
    const _fetch = window.fetch;
    window.fetch = function(resource, init) {
      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      const isAdd = /\/cart\/add(\.js)?/i.test(url);
      return _fetch.call(this, resource, init).then(res => {
        if (isAdd && res && res.ok) setTimeout(() => showCTA(getOpenDrawer()), 50);
        return res;
      });
    };
  }

  // XHR fallback (por si el theme usa XMLHttpRequest)
  if (!window.__CIB_CTA_XHR_PATCHED) {
    window.__CIB_CTA_XHR_PATCHED = true;
    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__cib_is_add = url && /\/cart\/add(\.js)?/i.test(url.toString());
      return _open.apply(this, arguments);
    };
    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(body) {
      this.addEventListener('load', () => {
        if (this.__cib_is_add && this.status >= 200 && this.status < 300) {
          setTimeout(() => showCTA(getOpenDrawer()), 50);
        }
      });
      return _send.apply(this, arguments);
    };
  }

  // Hide CTA when drawer closes
  document.addEventListener(
    'click',
    e => {
      if (e.target.closest('.drawer__close-btn, .js-close-drawer, [data-close-drawer]')) hideAllCTA();
    },
    { passive: true }
  );

  // Also hide on ESC
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') hideAllCTA();
  });
})();
